export default "/profile/images/viber.png?12797ce7c992eb4fd5b40e96fa3a4168";